module.exports = __webpack_public_path__ + "img/knight3_01.25bff00c.jpg";